module.exports = __webpack_public_path__ + "static/media/parts_17.40d9a71f.svg";